/** Ids read as `#027` — padded to three, then allowed to grow (`#1042`). */
export function formatUserId(id: number): string {
  return `#${String(id).padStart(3, '0')}`;
}
